import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { NotificationService } from '../services/notification.service';
import { userFriendlyHttpError } from '../utils/http-error-message';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const silentPublicRequest = req.url.includes('/public/portal-content') || /\/health(?:\?|$)/.test(req.url);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!silentPublicRequest) notificationService.showError(userFriendlyHttpError(error));
      return throwError(() => error);
    }),
  );
};
